import { useState } from 'react';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { useAdminLogin, useSession } from '../auth/useSession.js';

/**
 * Username/password sign-in for the consultancy admin portal. Employees and vendor admins still use
 * the magic-link flow on /login; this page exists only so admins can get straight into /admin.
 */
export function AdminLoginPage() {
  const [searchParams] = useSearchParams();
  const session = useSession();
  const login = useAdminLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const redirectTo = searchParams.get('redirectTo') ?? undefined;

  if (session.data?.capabilities.manageVendors) {
    return <Navigate to={redirectTo ?? '/admin'} replace />;
  }

  return (
    <main className="auth">
      <div className="auth-card">
        <Link to="/" className="auth-wordmark">
          Voice <span className="to">to</span> Value
        </Link>
        <h1>Admin sign-in</h1>
        <p className="auth-sub">Sign in to manage companies, surveys and results.</p>

        <form
          onSubmit={(event) => {
            event.preventDefault();
            login.mutate({ email, password });
          }}
        >
          {login.isError && (
            <p className="auth-error" role="alert">
              {login.error.message}
            </p>
          )}

          <div className="auth-field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              required
              autoComplete="username"
              autoFocus
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>

          <div className="auth-field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>

          <button type="submit" disabled={login.isPending}>
            {login.isPending ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </main>
  );
}
